import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { rootLoader } from "./routes/guards/rootLoader";

//#region Public Pages
import HomeLayout from "./layouts/HomeLayout";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import AboutHub from "./pages/About/AboutHub";
import Scene from "./pages/About/scenes/Scene";
import UniverseInfo from "./pages/UniverseInfo/UniverseInfo";
import AgeGate from "./pages/AgeGate/AgeGate";
import { action as ageGateAction } from "./pages/AgeGate/action";
import Underage from "./pages/Underage/Underage";
import Suspended from "./pages/Suspended/Suspended";
import Banned from "./pages/Banned/Banned";
import Deleted from "./pages/Deleted/Deleted";
import LanguageSelect from "./pages/LanguageSelect/LanguageSelect";
import { action as languageAction } from "./pages/LanguageSelect/action";
import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";
import CitizenshipType from "./pages/CitizenshipType/CitizenshipType";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import NotyVlogComingSoon from "./pages/NotyVlogComingSoon/NotyVlogComingSoon";
import Terms from "./pages/Terms/Terms";
import ErrorPage from "./pages/Error/Error";
import GameEnterPage from "./pages/game/GameEnterPage";
import GameProfileSetupPage from "./pages/game/GameProfileSetupPage";
import GameLobbyPage from "./pages/game/GameLobbyPage";
//#endregion Public Pages

//#region Layouts
import AdminLayout from "./layouts/AdminLayout";
import EditorLayout from "./layouts/EditorLayout";
import LoungeLayout from "./layouts/LoungeLayout";
import MemberLayout from "./layouts/MemberLayout";

//#endregion Layouts

//#region Member Create Pages
import Welcome from "./pages/Member/CreateMember/Welcome/Welcome";
import CreateMemberLocal from "./pages/Member/CreateMember/CreateMemberLocal/CreateMemberLocal";
import CreateMemberAvatar from "./pages/Member/CreateMember/CreateMemberAvatar/CreateMemberAvatar";
import CreateMemberGender from "./pages/Member/CreateMember/CreateMemberGender/CreateMemberGender";
import CreateMemberRelation from "./pages/Member/CreateMember/CreateMemberRelation/CreateMemberRelation";
import CreateMemberSexualIdentity from "./pages/Member/CreateMember/CreateMemberSexualIdentity/CreateMemberSexualIdentity";
import CreateMemberAttractionGenders from "./pages/Member/CreateMember/CreateMemberAttractionGenders/CreateMemberAttractionGenders";
import CreateMemberSexualRole from "./pages/Member/CreateMember/CreateMemberSexualRole/CreateMemberSexualRole";
import CreateMemberConnectionTypes from "./pages/Member/CreateMember/CreateMemberConnectionTypes/CreateMemberConnectionTypes";
import CreateMemberIntimacyTypes from "./pages/Member/CreateMember/CreateMemberIntimacyTypes/CreateMemberIntimacyTypes";
import CreateMemberSexualFantasies from "./pages/Member/CreateMember/CreateMemberSexualFantasies/CreateMemberSexualFantasies";
import CreateMemberBodyType from "./pages/Member/CreateMember/CreateMemberBodyType/CreateMemberBodyType";
import CreateMemberBodyAttract from "./pages/Member/CreateMember/CreateMemberBodyAttract/CreateMemberBodyAttract";
import CreateMemberSexualEnvironment from "./pages/Member/CreateMember/CreateMemberSexualEnvironment/CreateMemberSexualEnvironment";
import CreateMemberEventAttract from "./pages/Member/CreateMember/CreateMemberEventAttract/CreateMemberEventAttract";
import CreateMemberAlcoholCannabis from "./pages/Member/CreateMember/CreateMemberAlcoholCannabis/CreateMemberAlcoholCannabis";
import CreateMemberBeMatched from "./pages/Member/CreateMember/CreateMemberBeMatched/CreateMemberBeMatched";
import CreateMemberJoinHost from "./pages/Member/CreateMember/CreateMemberJoinHost/CreateMemberJoinHost";
import CreateMemberRealImage from "./pages/Member/CreateMember/CreateMemberRealImage/CreateMemberRealImage";
import CreateMemberSocial from "./pages/Member/CreateMember/CreateMemberSocial/CreateMemberSocial";
import CreateMemberPayment from "./pages/Member/CreateMember/CreateMemberPayment/CreateMemberPayment";
import CreateMemberPending from "./pages/Member/CreateMember/CreateMemberPending/CreateMemberPending";
import MyProfile from "./pages/Member/Profile/MyProfile/MyProfile";
import LoginInfo from "./pages/Member/Profile/LoginInfo/LoginInfo";
import PersonalInfo from "./pages/Member/Profile/PersonalInfo/PersonalInfo";
import LifestyleInfo from "./pages/Member/Profile/LifestyleInfo/LifestyleInfo";
import Partners from "./pages/Member/Profile/Partners/Partners";
import PartnerSingle from "./pages/Member/Profile/PartnerSingle/PartnerSingle";
import PartnerPersonalInfo from "./pages/Member/Profile/PartnerPersonalInfo/PartnerPersonalInfo";
import PartnerLifestyleInfo from "./pages/Member/Profile/PartnerLifestyleInfo/PartnerLifestyleInfo";
import CreatePartner from "./pages/Member/Profile/CreatePartner/CreatePartner";
import VerifyEmailChange from "./pages/Member/Profile/VerifyEmailChange/VerifyEmailChange";
import MemberNotification from "./pages/Member/MemberNotification/MemberNotification";
import Wallet from "./pages/Member/Wallet/Wallet";
import WalletETransfer from "./pages/Member/WalletETransfer/WalletETransfer";
import WalletPromoRedeem from "./pages/Member/WalletPromoRedeem/WalletPromoRedeem";
import MemberChat from "./pages/Member/Chat/Chat";
//#endregion Member Create Pages

//#region Lounge Pages
import { NotificationProvider } from "./app/notification-context";
import { CallProvider } from "./app/call-context";
import MyNotifications from "./pages/Lounge/MyNotifications/MyNotifications";
import CallDetails from "./pages/Lounge/Calls/CallDetails";
import MemberProfileAbout from "./pages/Lounge/Profile/MemberProfileAbout/MemberProfileAbout";
import MemberProfileOverView from "./pages/Lounge/Profile/MemberProfileOverView/MemberProfileOverView";
import MemberPublicFeed from "./pages/Lounge/MemberPublicFeed/MemberPublicFeed";
import MemberFriendsFeed from "./pages/Lounge/MemberFriendsFeed/MemberFriendsFeed";
import MemberClubsFeed from "./pages/Lounge/MemberClubsFeed/MemberClubsFeed";
import ChatList from "./pages/Lounge/Chat/ChatList/ChatList";
import ChatSingle from "./pages/Lounge/Chat/ChatSingle/ChatSingle";
import MemberProfileEdit from "./pages/Lounge/Profile/MemberProfileEdit/MemberProfileEdit";
import MemberProfileEditLogin from "./pages/Lounge/Profile/MemberProfileEditLogin/MemberProfileEditLogin";
import MemberProfileEditMember from "./pages/Lounge/Profile/MemberProfileEditMember/MemberProfileEditMember";
import MemberProfileEditPersonal from "./pages/Lounge/Profile/MemberProfileEditPersonal/MemberProfileEditPersonal";
import MemberProfileEditLifestyle from "./pages/Lounge/Profile/MemberProfileEditLifestyle/MemberProfileEditLifestyle";
import MemberProfileEditPartners from "./pages/Lounge/Profile/MemberProfileEditPartners/MemberProfileEditPartners";
import MemberProfileEditPartnersNew from "./pages/Lounge/Profile/MemberProfileEditPartnersNew/MemberProfileEditPartnersNew";
import MemberProfileEditPartnersSingle from "./pages/Lounge/Profile/MemberProfileEditPartnersSingle/MemberProfileEditPartnersSingle";
import MemberProfileEditPartnersPersonal from "./pages/Lounge/Profile/MemberProfileEditPartnersPersonal/MemberProfileEditPartnersPersonal";
import MemberProfileEditPartnersLifestyle from "./pages/Lounge/Profile/MemberProfileEditPartnersLifestyle/MemberProfileEditPartnersLifestyle";
import MemberProfileEditPayments from "./pages/Lounge/Profile/MemberProfileEditPayments/MemberProfileEditPayments";
import MemberProfileEditPaymentsNew from "./pages/Lounge/Profile/MemberProfileEditPaymentsNew/MemberProfileEditPaymentsNew";
import MemberProfileEditPaymentsSingle from "./pages/Lounge/Profile/MemberProfileEditPaymentsSingle/MemberProfileEditPaymentsSingle";
import MemberProfile from "./pages/Lounge/Profile/MemberProfile/MemberProfile";
import LoungeMemberAbout from "./pages/Lounge/Profile/LoungeMemberAbout/LoungeMemberAbout";
import LoungeMemberFriends from "./pages/Lounge/Profile/LoungeMemberFriends/LoungeMemberFriends";
import MemberSearch from "./pages/Lounge/MemberSearch/MemberSearch";
import PendingRequests from "./pages/Lounge/Friends/PendingRequests/PendingRequests";
import MyFriends from "./pages/Lounge/Friends/MyFriends/MyFriends";
import SearchClubs from "./pages/Lounge/Clubs/SearchClubs/SearchClubs";
import SearchClubsCity from "./pages/Lounge/Clubs/SearchClubsCity/SearchClubsCity";
import SearchClubsStreet from "./pages/Lounge/Clubs/SearchClubsStreet/SearchClubsStreet";
import ExploreUniverse from "./pages/Lounge/Clubs/ExploreUniverse/ExploreUniverse";
import ExploreCitySingle from "./pages/Lounge/Clubs/ExploreCitySingle/ExploreCitySingle";
import ClubSingle from "./pages/Lounge/Clubs/ClubSingle/ClubSingle";
import ExploreStreetSingle from "./pages/Lounge/Clubs/ExploreStreetSingle/ExploreStreetSingle";
import ClubAbout from "./pages/Lounge/Clubs/ClubAbout/ClubAbout";
import LoungeClubRules from "./pages/Lounge/Clubs/LoungeClubRules/LoungeClubRules";
import LoungeJoinSingle from "./pages/Lounge/Clubs/LoungeJoinSingle/LoungeJoinSingle";
import LoungeJoin from "./pages/Lounge/Clubs/LoungeJoin/LoungeJoin";
import MyClubs from "./pages/Lounge/Clubs/MyClubs/MyClubs";
import ClubEvents from "./pages/Lounge/Clubs/ClubEvents/ClubEvents";
import ClubShop from "./pages/Lounge/Clubs/ClubShop/ClubShop";
import MarketplaceRouteShell from "./pages/Lounge/Marketplace/MarketplaceRouteShell";
import ClubMarketplaceListPage from "./pages/Lounge/Marketplace/ClubMarketplaceListPage";
import MarketplaceProductDetailPage from "./pages/Lounge/Marketplace/MarketplaceProductDetailPage";
import SellerMarketplaceDashboard from "./pages/Lounge/Marketplace/SellerMarketplaceDashboard";
import MarketplaceProductWizard from "./pages/Lounge/Marketplace/MarketplaceProductWizard";
import ClubHome from "./pages/Lounge/Clubs/ClubHome/ClubHome";
import LoungeClubMembers from "./pages/Lounge/Clubs/ClubMembers/ClubMembers";
import PartnerDashboard from "./pages/Lounge/Clubs/PartnerDashboard/PartnerDashboard";
import PostSingle from "./pages/Lounge/PostSingle/PostSingle";
import LoungeWallet from "./pages/Lounge/Wallet/Wallet";
import LoungeWalletETransfer from "./pages/Lounge/WalletETransfer/WalletETransfer";
import LoungeWalletPromoRedeem from "./pages/Lounge/WalletPromoRedeem/WalletPromoRedeem";

//#endregion Lounge Pages

//#region Admin Pages
import AdminDashboard from "./pages/Admin/AdminDashboard/AdminDashboard";
import AdminMembersStats from "./pages/Admin/Members/AdminMembersStats/AdminMembersStats";
import JustRegisteredNotEmailVerified from "./pages/Admin/Members/JustRegisteredNotEmailVerified/JustRegisteredNotEmailVerified";
import StillCreatingProfile from "./pages/Admin/Members/StillCreatingProfile/StillCreatingProfile";
import ThatPending from "./pages/Admin/Members/ThatPending/ThatPending";
import ThatApproved from "./pages/Admin/Members/ThatApproved/ThatApproved";
import SuspendedUsers from "./pages/Admin/Members/SuspendedUsers/SuspendedUsers";
import MembersWithoutProfile from "./pages/Admin/Members/MembersWithoutProfile/MembersWithoutProfile";
import BannedUsers from "./pages/Admin/Members/BannedUsers/BannedUsers";
import DeletedUsers from "./pages/Admin/Members/DeletedUsers/DeletedUsers";
import SingleUser from "./pages/Admin/Members/SingleUser/SingleUser";
import UserLoginInfo from "./pages/Admin/Members/UserLoginInfo/UserLoginInfo";
import UserMemberInfo from "./pages/Admin/Members/UserMemberInfo/UserMemberInfo";
import UserMemberPersonalInfo from "./pages/Admin/Members/UserMemberPersonalInfo/UserMemberPersonalInfo";
import UserMemberLifestyleInfo from "./pages/Admin/Members/UserMemberLifestyleInfo/UserMemberLifestyleInfo";
import UserMemberPartners from "./pages/Admin/Members/UserMemberPartners/UserMemberPartners";
import UserMemberPartnerSingle from "./pages/Admin/Members/UserMemberPartnerSingle/UserMemberPartnerSingle";
import UserMemberPartnerRelation from "./pages/Admin/Members/UserMemberPartnerRelation/UserMemberPartnerRelation";
import UserMemberPartnerPersonal from "./pages/Admin/Members/UserMemberPartnerPersonal/UserMemberPartnerPersonal";
import UserMemberPartnerLifestyle from "./pages/Admin/Members/UserMemberPartnerLifestyle/UserMemberPartnerLifestyle";
import UserMemberPartnerCreate from "./pages/Admin/Members/UserMemberPartnerCreate/UserMemberPartnerCreate";
import UserMemberPaymentSubmissions from "./pages/Admin/Members/UserMemberPaymentSubmissions/UserMemberPaymentSubmissions";
import UserMemberPaymentSubmissionsSingle from "./pages/Admin/Members/UserMemberPaymentSubmissionsSingle/UserMemberPaymentSubmissionsSingle";
import UserMemberCreate from "./pages/Admin/Members/UserMemberCreate/UserMemberCreate";
import AdminMemberProfilePreview from "./pages/Admin/Members/AdminMemberProfilePreview/AdminMemberProfilePreview";
import UserPostsList from "./pages/Admin/Members/UserPostsList/UserPostsList";
import UserPostSingle from "./pages/Admin/Members/UserPostSingle/UserPostSingle";
import UserPostCreate from "./pages/Admin/Members/UserPostCreate/UserPostCreate";
import MemberEmail from "./pages/Admin/Members/MemberEmail/MemberEmail";
import AdminFriendRequestsMonitor from "./pages/Admin/FriendRequests/AdminFriendRequestsMonitor/AdminFriendRequestsMonitor";
import AdminNotificationsStats from "./pages/Admin/Notifications/AdminNotificationsStats/AdminNotificationsStats";
import AdminAllNotifications from "./pages/Admin/Notifications/AdminAllNotifications/AdminAllNotifications";
import CMS from "./pages/Admin/CMS/CMS/CMS";
import HomeCMS from "./pages/Admin/CMS/Home/HomeCMS";
import LanguageCMS from "./pages/Admin/CMS/Language/LanguageCMS";
import AdminWelcome from "./pages/Admin/CMS/AdminWelcome/AdminWelcome";
import PaymentSubmissions from "./pages/Admin/Finance/PaymentSubmissions/PaymentSubmissions";
import PaymentOptions from "./pages/Admin/Finance/PaymentOptions/PaymentOptions";
import PaymentOptionsCreate from "./pages/Admin/Finance/PaymentOptionsCreate/PaymentOptionsCreate";
import PaymentOptionsEdit from "./pages/Admin/Finance/PaymentOptionsEdit/PaymentOptionsEdit";
import ExchangeRates from "./pages/Admin/Finance/ExchangeRates/ExchangeRates";
import Wallets from "./pages/Admin/Finance/Wallets/Wallets";
import WalletDetail from "./pages/Admin/Finance/Wallets/WalletDetail";
import WalletTransactionDetail from "./pages/Admin/Finance/WalletTransactions/WalletTransactionDetail";
import LedgerEntries from "./pages/Admin/Finance/LedgerEntries/LedgerEntries";
import PromoCodes from "./pages/Admin/Finance/PromoCodes/PromoCodes";
import PromoRedemptions from "./pages/Admin/Finance/PromoRedemptions/PromoRedemptions";
import Reports from "./pages/Admin/Finance/Reports/Reports";
import Reconciliation from "./pages/Admin/Finance/Reconciliation/Reconciliation";
import AllAccounts from "./pages/Admin/Finance/AllAccounts/AllAccounts";
import BankAccount from "./pages/Admin/Finance/BankAccount/BankAccount";
import BankTransactionDetail from "./pages/Admin/Finance/BankTransactions/BankTransactionDetail";
import MarketingExpenseAccount from "./pages/Admin/Finance/MarketingExpenseAccount/MarketingExpenseAccount";
import MarketingExpenseEntryDetail from "./pages/Admin/Finance/MarketingExpenseEntries/MarketingExpenseEntryDetail";
import MembershipRevenueAccount from "./pages/Admin/Finance/MembershipRevenueAccount/MembershipRevenueAccount";
import MembershipRevenueEntryDetail from "./pages/Admin/Finance/MembershipRevenueEntries/MembershipRevenueEntryDetail";
import WalletLiabilityAccount from "./pages/Admin/Finance/WalletLiabilityAccount/WalletLiabilityAccount";
import WalletLiabilityEntryDetail from "./pages/Admin/Finance/WalletLiabilityEntries/WalletLiabilityEntryDetail";
import AdminCities from "./pages/Admin/City/AdminCities/AdminCities";
import AdminCreateCity from "./pages/Admin/City/AdminCreateCity/AdminCreateCity";
import AdminCitySingle from "./pages/Admin/City/AdminCitySingle/AdminCitySingle";
import AdminStreets from "./pages/Admin/City/AdminStreets/AdminStreets";
import AdminStreetCreate from "./pages/Admin/City/AdminStreetCreate/AdminStreetCreate";
import AdminStreetSingle from "./pages/Admin/City/AdminStreetSingle/AdminStreetSingle";
import AdminClubs from "./pages/Admin/City/AdminClubs/AdminClubs";
import AdminClubCreate from "./pages/Admin/City/AdminClubCreate/AdminClubCreate";
import AdminClubSingle from "./pages/Admin/City/AdminClubSingle/AdminClubSingle";
import ClubRules from "./pages/Admin/City/ClubRules/ClubRules";
import ClubRulesCreate from "./pages/Admin/City/ClubRulesCreate/ClubRulesCreate";
import ClubRuleSingle from "./pages/Admin/City/ClubRuleSingle/ClubRuleSingle";
import AdminStreetSearch from "./pages/Admin/City/AdminStreetSearch/AdminStreetSearch";
import AdminClubsSearch from "./pages/Admin/City/AdminClubsSearch/AdminClubsSearch";
import ClubRoles from "./pages/Admin/City/ClubRoles/ClubRoles";
import ClubMembers from "./pages/Admin/City/ClubMembers/ClubMembers";
import ClubMemberSingle from "./pages/Admin/City/ClubMemberSingle/ClubMemberSingle";
import ClubMemberRequests from "./pages/Admin/City/ClubMemberRequests/ClubMemberRequests";
import ClubActivities from "./pages/Admin/City/ClubActivities/ClubActivities";
import ClubMemberRequestsSingle from "./pages/Admin/City/ClubMemberRequestsSingle/ClubMemberRequestsSingle";
import AdminChatList from "./pages/Admin/Chat/ChatList/ChatList";
import AdminChatSingle from "./pages/Admin/Chat/ChatSingle/ChatSingle";
import AdminMessageMonitor from "./pages/Admin/Chat/MessageMonitor/MessageMonitor";
import AdminGameListPage from "./pages/Admin/game/AdminGameListPage";
import AdminGameCreatePage from "./pages/Admin/game/AdminGameCreatePage";
import AdminGameQuestionsPage from "./pages/Admin/game/AdminGameQuestionsPage";
import AddGameQuestionPage from "./pages/Admin/game/AddGameQuestionPage";
import SingleGameQuestionPage from "./pages/Admin/game/SingleGameQuestionPage";
import AdminGameSinglePage from "./pages/Admin/game/AdminGameSinglePage";
import AdminMarketplaceRouteShell from "./pages/Admin/Marketplace/AdminMarketplaceRouteShell";
import AdminPendingProductDetailPage from "./pages/Admin/Marketplace/AdminPendingProductDetailPage";
import AdminPendingProductsPage from "./pages/Admin/Marketplace/AdminPendingProductsPage";
import AdminAllProductsPage from "./pages/Admin/Marketplace/AdminAllProductsPage";
import AdminEditProductPage from "./pages/Admin/Marketplace/AdminEditProductPage";
import AdminEmailCenter from "./pages/Admin/EmailCenter/AdminEmailCenter";
//#endregion Admin Pages

import EditorDashboard from "./pages/Editor/EditorDashboard/EditorDashboard";

import { roleGuard } from "./routes/guards/authLoaders";
import { ROLES } from "./app/constants";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    loader: rootLoader,
    errorElement: <ErrorPage />,
    hydrateFallbackElement: <div className="route-loading" />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "about-us",
        element: <About />,
        children: [
          { index: true, element: <AboutHub /> },
          { path: ":id", element: <Scene /> }, // id ∈ ORDER
        ],
      },
      {
        path: "universe",
        element: <UniverseInfo />,
      },
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "verify-email", element: <VerifyEmail /> },
      {
        path: "/verify-email-change",
        element: <VerifyEmailChange />,
      },
      { path: "reset-password", element: <ResetPassword /> },
      { path: "noty-network", element: <NotyVlogComingSoon /> },
      {
        path: "terms",
        element: <Terms />,
      },
      { path: "/game/enter", element: <GameEnterPage /> },
    ],
  },

  // Public / utility
  { path: "/age", element: <AgeGate />, action: ageGateAction },
  { path: "/underage", element: <Underage /> },
  { path: "/account/suspended", element: <Suspended /> },
  { path: "/account/banned", element: <Banned /> },
  { path: "/account/deleted", element: <Deleted /> },
  { path: "/language", element: <LanguageSelect />, action: languageAction },
  { path: "/game/profile-setup", element: <GameProfileSetupPage /> },
  { path: "/game/:gameId/lobby", element: <GameLobbyPage /> },

  // NEW: Admin area (active + admin only)
  {
    path: "/admin",
    element: (
      <CallProvider>
        <AdminLayout />
      </CallProvider>
    ),
    loader: roleGuard([ROLES.ADMIN]),
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "members", element: <AdminMembersStats /> },
      {
        path: "members/just-registered-not-email-verified",
        element: <JustRegisteredNotEmailVerified />,
      },
      {
        path: "members/still-creating-profile",
        element: <StillCreatingProfile />,
      },
      {
        path: "members/that-pending",
        element: <ThatPending />,
      },
      {
        path: "members/that-approved",
        element: <ThatApproved />,
      },
      {
        path: "members/suspended-users",
        element: <SuspendedUsers />,
      },
      {
        path: "members/without-profile",
        element: <MembersWithoutProfile />,
      },
      {
        path: "members/banned-users",
        element: <BannedUsers />,
      },
      {
        path: "members/deleted-users",
        element: <DeletedUsers />,
      },
      {
        path: "members/single/:userId",
        element: <SingleUser />,
      },
      {
        path: "users/:userId",
        element: <SingleUser />,
      },
      {
        path: "members/single/login-info/:userId",
        element: <UserLoginInfo />,
      },
      {
        path: "members/single/member-info/:userId",
        element: <UserMemberInfo />,
      },
      {
        path: "members/single/member-personal-info/:userId",
        element: <UserMemberPersonalInfo />,
      },
      {
        path: "members/single/member-lifestyle-info/:userId",
        element: <UserMemberLifestyleInfo />,
      },
      {
        path: "members/single/partners-info/:userId",
        element: <UserMemberPartners />,
      },
      {
        path: "members/single/partners-info/single/:userId/:partnerId",
        element: <UserMemberPartnerSingle />,
      },
      {
        path: "members/single/partners-info/relation/:userId/:partnerId",
        element: <UserMemberPartnerRelation />,
      },
      {
        path: "members/single/partners-info/personal/:userId/:partnerId",
        element: <UserMemberPartnerPersonal />,
      },
      {
        path: "members/single/partners-info/lifestyle/:userId/:partnerId",
        element: <UserMemberPartnerLifestyle />,
      },
      {
        path: "members/single/partners-create/:userId",
        element: <UserMemberPartnerCreate />,
      },
      {
        path: "members/single/payment-info/:userId",
        element: <UserMemberPaymentSubmissions />,
      },
      {
        path: "members/single/payment-info/single/:userId/:memberPaymentSubmissionId",
        element: <UserMemberPaymentSubmissionsSingle />,
      },
      { path: "citizenship", element: <CitizenshipType /> },
      {
        path: "members/create",
        element: <UserMemberCreate />,
      },
      {
        path: "members/single/profile-preview/:userId",
        element: <AdminMemberProfilePreview />,
      },
      {
        path: "members/single/posts/:userId",
        element: <UserPostsList />,
      },
      {
        path: "members/single/posts/:userId/:postId",
        element: <UserPostSingle />,
      },
      {
        path: "members/single/posts/:userId/create",
        element: <UserPostCreate />,
      },
      {
        path: "members/email/:userId",
        element: <MemberEmail />,
      },
      { path: "chat", element: <AdminChatList /> },
      { path: "emails", element: <AdminEmailCenter /> },
      { path: "chat/monitor", element: <AdminMessageMonitor /> },
      { path: "notifications", element: <AdminNotificationsStats /> },
      { path: "friend-requests", element: <AdminFriendRequestsMonitor /> },
      { path: "notifications/all", element: <AdminAllNotifications /> },
      { path: "cities", element: <AdminCities /> },
      { path: "cities/create", element: <AdminCreateCity /> },
      { path: "cities/single/:cityId", element: <AdminCitySingle /> },
      { path: "cities/single/:cityId/streets", element: <AdminStreets /> },
      {
        path: "cities/single/:cityId/streets/create",
        element: <AdminStreetCreate />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId",
        element: <AdminStreetSingle />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs",
        element: <AdminClubs />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/create",
        element: <AdminClubCreate />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId",
        element: <AdminClubSingle />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId/rules",
        element: <ClubRules />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId/rules/create",
        element: <ClubRulesCreate />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId/rules/:clubRuleId",
        element: <ClubRuleSingle />,
      },
      { path: "streets", element: <AdminStreetSearch /> },
      { path: "clubs", element: <AdminClubsSearch /> },
      { path: "cms", element: <CMS /> },
      { path: "home-cms", element: <HomeCMS /> },
      { path: "language-cms", element: <LanguageCMS /> },
      { path: "admin-welcome", element: <AdminWelcome /> },
      { path: "finance/accounts", element: <AllAccounts /> },
      { path: "finance/accounts/bank", element: <BankAccount /> },
      {
        path: "finance/accounts/bank/transactions/:entryId",
        element: <BankTransactionDetail />,
      },
      {
        path: "finance/accounts/marketing-expense",
        element: <MarketingExpenseAccount />,
      },
      {
        path: "finance/accounts/marketing-expense/transactions/:entryId",
        element: <MarketingExpenseEntryDetail />,
      },
      {
        path: "finance/accounts/membership-revenue",
        element: <MembershipRevenueAccount />,
      },
      {
        path: "finance/accounts/membership-revenue/transactions/:entryId",
        element: <MembershipRevenueEntryDetail />,
      },
      {
        path: "finance/accounts/wallet-liability",
        element: <WalletLiabilityAccount />,
      },
      {
        path: "finance/accounts/wallet-liability/transactions/:entryId",
        element: <WalletLiabilityEntryDetail />,
      },
      { path: "finance/payment-submissions", element: <PaymentSubmissions /> },
      { path: "finance/payment-options", element: <PaymentOptions /> },
      {
        path: "finance/payment-options/create",
        element: <PaymentOptionsCreate />,
      },
      {
        path: "finance/payment-options/:id",
        element: <PaymentOptionsEdit />,
      },
      { path: "finance/exchange-rates", element: <ExchangeRates /> },
      { path: "finance/wallets", element: <Wallets /> },
      { path: "finance/wallets/:walletId", element: <WalletDetail /> },
      {
        path: "finance/wallets/:walletId/transactions/:transactionId",
        element: <WalletTransactionDetail />,
      },
      { path: "finance/ledger-entries", element: <LedgerEntries /> },
      { path: "finance/promos", element: <PromoCodes /> },
      { path: "finance/promo-redemptions", element: <PromoRedemptions /> },
      { path: "finance/reports", element: <Reports /> },
      { path: "finance/reconciliation", element: <Reconciliation /> },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId/roles",
        element: <ClubRoles />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId/members",
        element: <ClubMembers />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId/memberships/:membershipId",
        element: <ClubMemberSingle />,
      },
      {
        path: "clubs/single/:clubId/membership-requests",
        element: <ClubMemberRequests />,
      },
      {
        path: "cities/single/:cityId/streets/:streetId/clubs/:clubId/activities",
        element: <ClubActivities />,
      },
      {
        path: "clubs/single/:clubId/membership-requests/:clubJoinRequestId",
        element: <ClubMemberRequestsSingle />,
      },
      { path: "games", element: <AdminGameListPage /> },
      { path: "games/create", element: <AdminGameCreatePage /> },
      { path: "games/:gameId", element: <AdminGameSinglePage /> },
      { path: "game-questions", element: <AdminGameQuestionsPage /> },
      { path: "game-questions/add", element: <AddGameQuestionPage /> },
      {
        path: "game-questions/:questionId",
        element: <SingleGameQuestionPage />,
      },
      {
        path: "marketplace",
        element: <AdminMarketplaceRouteShell />,
        children: [
          { index: true, element: <AdminPendingProductsPage /> },
          { path: "pending-products", element: <AdminPendingProductsPage /> },
          { path: "all-products", element: <AdminAllProductsPage /> },
          {
            path: "pending-products/:productId",
            element: <AdminPendingProductDetailPage />,
          },
          {
            path: "pending-products/:productId/edit",
            element: <AdminEditProductPage />,
          },
        ],
      },
    ],
  },

  // NEW: Editor area (active + editor only)
  {
    path: "/editor",
    element: <EditorLayout />,
    loader: roleGuard([ROLES.EDITOR]),
    children: [{ index: true, element: <EditorDashboard /> }],
  },

  // NEW: Member Lounge (active + member only) — Phase 1 generic lounge
  {
    path: "/lounge",
    element: (
      <NotificationProvider>
        <CallProvider>
          <LoungeLayout />
        </CallProvider>
      </NotificationProvider>
    ),
    loader: roleGuard([ROLES.MEMBER]),
    children: [
      { index: true, element: <MemberPublicFeed /> },
      { path: "my-notifications", element: <MyNotifications /> },
      { path: "calls", element: <CallDetails /> },
      { path: "wallet", element: <LoungeWallet /> },
      { path: "wallet/e-transfer", element: <LoungeWalletETransfer /> },
      { path: "wallet/redeem", element: <LoungeWalletPromoRedeem /> },
      { path: "my-profile", element: <MemberProfileOverView /> },
      { path: "my-profile/about", element: <MemberProfileAbout /> },
      { path: "my-profile/edit", element: <MemberProfileEdit /> },
      {
        path: "my-profile/edit/login-info",
        element: <MemberProfileEditLogin />,
      },
      {
        path: "my-profile/edit/member-info",
        element: <MemberProfileEditMember />,
      },
      {
        path: "my-profile/edit/personal-info",
        element: <MemberProfileEditPersonal />,
      },
      {
        path: "my-profile/edit/lifestyle-info",
        element: <MemberProfileEditLifestyle />,
      },
      {
        path: "my-profile/edit/partners",
        element: <MemberProfileEditPartners />,
      },
      {
        path: "my-profile/edit/partners/new",
        element: <MemberProfileEditPartnersNew />,
      },
      {
        path: "my-profile/edit/partners/:partnerId",
        element: <MemberProfileEditPartnersSingle />,
      },
      {
        path: "my-profile/edit/partners/personal-info/:partnerId",
        element: <MemberProfileEditPartnersPersonal />,
      },
      {
        path: "my-profile/edit/partners/lifestyle-info/:partnerId",
        element: <MemberProfileEditPartnersLifestyle />,
      },
      {
        path: "my-profile/edit/payments",
        element: <MemberProfileEditPayments />,
      },
      {
        path: "my-profile/edit/payments/:memberPaymentSubmissionId",
        element: <MemberProfileEditPaymentsSingle />,
      },
      {
        path: "my-profile/edit/payments/new",
        element: <MemberProfileEditPaymentsNew />,
      },
      {
        path: "search",
        element: <MemberSearch />,
      },
      {
        path: "member-profile/:memberId",
        element: <MemberProfile />,
      },
      {
        path: "member-profile/:memberId/about",
        element: <LoungeMemberAbout />,
      },
      {
        path: "member-profile/:memberId/friends",
        element: <LoungeMemberFriends />,
      },
      {
        path: "friends/requests",
        element: <PendingRequests />,
      },
      {
        path: "friends",
        element: <MyFriends />,
      },
      {
        path: "friends-feed",
        element: <MemberFriendsFeed />,
      },
      {
        path: "clubs-feed",
        element: <MemberClubsFeed />,
      },
      {
        path: "chat",
        element: <ChatList />,
      },
      {
        path: "search-clubs",
        element: <SearchClubs />,
      },
      {
        path: "search-clubs/city/:cityId",
        element: <SearchClubsCity />,
      },
      {
        path: "search-clubs/city/:cityId/:streetId",
        element: <SearchClubsStreet />,
      },
      {
        path: "explore-universe",
        element: <ExploreUniverse />,
      },
      {
        path: "cities/single/:cityId",
        element: <ExploreCitySingle />,
      },
      {
        path: "clubs/single/:clubId",
        element: <ClubSingle />,
      },
      {
        path: "streets/single/:streetId",
        element: <ExploreStreetSingle />,
      },
      {
        path: "clubs/single/:clubId/about",
        element: <ClubAbout />,
      },
      {
        path: "clubs/single/:clubId/rules",
        element: <LoungeClubRules />,
      },
      {
        path: "clubs/single/:clubId/membership-requests/:clubJoinRequestId",
        element: <LoungeJoinSingle />,
      },
      {
        path: "clubs/single/:clubId/membership-requests/",
        element: <LoungeJoin />,
      },
      {
        path: "my-clubs",
        element: <MyClubs />,
      },
      {
        path: "clubs/single/:clubId/home",
        element: <ClubHome />,
      },
      {
        path: "clubs/single/:clubId/events",
        element: <ClubEvents />,
      },
      {
        path: "clubs/single/:clubId/shop",
        element: <ClubShop />,
      },
      {
        path: "marketplace/:clubId/*",
        element: <MarketplaceRouteShell />,
        children: [
          { index: true, element: <ClubMarketplaceListPage /> },
          {
            path: "products/:productId",
            element: <MarketplaceProductDetailPage />,
          },
          {
            path: "seller",
            element: <SellerMarketplaceDashboard />,
          },
          {
            path: "seller/new",
            element: <MarketplaceProductWizard />,
          },
          {
            path: "seller/:productId/edit",
            element: <MarketplaceProductWizard />,
          },
        ],
      },
      {
        path: "clubs/single/:clubId/members",
        element: <LoungeClubMembers />,
      },
      {
        path: "clubs/single/:clubId/partner-dashboard",
        element: <PartnerDashboard />,
      },
      {
        path: "single-post/:postId",
        element: <PostSingle />,
      },
    ],
  },
  {
    path: "/member",
    element: (
      <CallProvider>
        <MemberLayout />
      </CallProvider>
    ),
    loader: roleGuard([ROLES.MEMBER]),
    children: [
      { index: true, element: <Welcome /> },
      { path: "notifications", element: <MemberNotification /> },
      { path: "wallet", element: <Wallet /> },
      { path: "wallet/e-transfer", element: <WalletETransfer /> },
      { path: "wallet/redeem", element: <WalletPromoRedeem /> },
      { path: "citizenship", element: <CitizenshipType /> },
      { path: "local", element: <CreateMemberLocal /> },
      { path: "avatar", element: <CreateMemberAvatar /> },
      { path: "gender", element: <CreateMemberGender /> },
      { path: "relation", element: <CreateMemberRelation /> },
      { path: "sexual_identity", element: <CreateMemberSexualIdentity /> },
      { path: "sexual_role", element: <CreateMemberSexualRole /> },
      {
        path: "attraction_genders",
        element: <CreateMemberAttractionGenders />,
      },
      {
        path: "connection_types",
        element: <CreateMemberConnectionTypes />,
      },
      {
        path: "intimacy_types",
        element: <CreateMemberIntimacyTypes />,
      },
      {
        path: "sexual_fantasies",
        element: <CreateMemberSexualFantasies />,
      },
      {
        path: "body_type",
        element: <CreateMemberBodyType />,
      },
      {
        path: "body_attract",
        element: <CreateMemberBodyAttract />,
      },
      {
        path: "sexual_environment",
        element: <CreateMemberSexualEnvironment />,
      },
      {
        path: "event_attract",
        element: <CreateMemberEventAttract />,
      },
      {
        path: "alcohol_cannabis",
        element: <CreateMemberAlcoholCannabis />,
      },
      {
        path: "be_matched",
        element: <CreateMemberBeMatched />,
      },
      {
        path: "join_host",
        element: <CreateMemberJoinHost />,
      },
      {
        path: "real_image",
        element: <CreateMemberRealImage />,
      },
      {
        path: "social",
        element: <CreateMemberSocial />,
      },
      {
        path: "payment",
        element: <CreateMemberPayment />,
      },
      {
        path: "pending",
        element: <CreateMemberPending />,
      },
      {
        path: "my-profile",
        element: <MyProfile />,
      },
      {
        path: "my-profile/login-info",
        element: <LoginInfo />,
      },
      {
        path: "my-profile/personal-info",
        element: <PersonalInfo />,
      },
      {
        path: "my-profile/lifestyle-info",
        element: <LifestyleInfo />,
      },
      {
        path: "my-profile/partners",
        element: <Partners />,
      },
      {
        path: "my-profile/partners/:partnerId",
        element: <PartnerSingle />,
      },
      {
        path: "my-profile/partners/personal-info/:partnerId",
        element: <PartnerPersonalInfo />,
      },
      {
        path: "my-profile/partners/lifestyle-info/:partnerId",
        element: <PartnerLifestyleInfo />,
      },
      {
        path: "my-profile/partners/new",
        element: <CreatePartner />,
      },
    ],
  },
  {
    path: "/lounge/chat/:memberId",
    element: <ChatSingle />,
    loader: roleGuard([ROLES.MEMBER]),
  },
  {
    path: "/member/chat",
    element: <MemberChat />,
    loader: roleGuard([ROLES.MEMBER]),
  },
  {
    path: "/admin/chat/:memberId",
    element: <AdminChatSingle />,
    loader: roleGuard([ROLES.ADMIN]),
  },
]);

export default function App() {
  return (
    <>
      <RouterProvider
        router={router}
        fallbackElement={<div className="route-loading" />}
      />
    </>
  );
}
